/*eslint-disable*/

import { getPaidTxDetails, getPaymentStatus, getTxInfo, initPayment } from '@api/payments';
import billingSummaryIcon from '@assets/misc-icons/billing-summary.svg';
import refundIcon from '@assets/misc-icons/refund.svg';
import paymentBlueBackground from '@assets/misc/payment-blue-background.svg';
import AdditionalDiscountIcon from '@assets/payment/additional-discount.svg';
import GrandTotalIcon from '@assets/payment/grand-total.svg';
import ItemTotalIcon from '@assets/payment/item-total.svg';
import OfferDiscountIcon from '@assets/payment/offer-discount.svg';
import TaxesIcon from '@assets/payment/taxes.svg';
import ToPayIcon from '@assets/payment/to-pay.svg';
import { getTagStructuredData } from '@components/status-tag';
import BackgroundLetterAvatars from '@components/ui/background-letter-avatars';
import HeadingArrowWrapper from '@components/ui/heading-arrow-wrapper';
import { fetchServices } from '@containers/evaluation-partner/services';
import { DATA_TEST_IDS } from '@data-test-ids';
import { CES_ORG, WES_ORG } from '@global/constants/general';
import SDK_LIST from '@global/constants/sdk';
import { paymentProvider, paymentProvidersTypes } from '@global/constants/verification';
import { convertToTitleCase, displayTime, isClientCareerMosaic, useQuery } from '@global/helpers/general';
import useShake from '@global/hooks/useShake';
import { mixpanel, trackingEvents } from '@global/monitoring/mixpanel';
import { themes } from '@global/types/common';
import { ContentCopy, InfoOutlined, ReceiptLongOutlined } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import {
  Alert,
  Avatar,
  Box,
  Chip,
  Divider,
  Grid,
  keyframes,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Stack,
  Tooltip,
  Typography
} from '@mui/material';
import { updateMiscStore } from '@redux/slices/misc';
import { RootState } from '@redux/store';
import { showSnackbar } from '@services/snackbar';
import { default as React, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import styles from './styles';

const style = {
  // py: 0,
  width: '100%',
  // maxWidth: 360,
  borderRadius: 2,
  // border: '0.1px solid',
  // borderColor: '#F6F9FC',
  backgroundColor: 'background.paper'
  // marginTop: 2
};

const dividerStyle = { height: '0.01px', border: 'none', borderTop: '1px solid #F2F7FF' };

const blink = keyframes`
  0% { transform: translate(0.2px, 0.2px) rotate(0deg); }
  10% { transform: translate(-0.2px, -0.5px) rotate(-1deg); }
  20% { transform: translate(-0.2px, 0px) rotate(1deg); }
  30% { transform: translate(0.2px, 0.5px) rotate(0deg); }
  40% { transform: translate(0.2px, -0.2px) rotate(1deg); }
  50% { transform: translate(-0.2px, 0.5px) rotate(-1deg); }
  60% { transform: translate(-0.2px, 0.2px) rotate(0deg); }
  70% { transform: translate(0.2px, 0.2px) rotate(-1deg); }
  80% { transform: translate(-0.2px, -0.2px) rotate(1deg); }
  90% { transform: translate(0.2px, 0.5px) rotate(0deg); }
  100% { transform: translate(0.2px, -0.5px) rotate(0deg); }
`;

const Payment = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const express = state?.expressOpted || false;
  const phoneNumber = state?.phoneNumber || null;
  const { startShake, shakeRef } = useShake();
  const [txInfo, setTxInfo] = useState<any>([]);
  const [paymentStatus, setPaymentStatus] = useState('');

  const searchParams = useQuery();
  const { configs } = useSelector((s: RootState) => s.verification);
  const [loadingData, setLoadingData] = useState(true);
  const [previousRegion, setPreviousRegion] = useState(null);
  const [showCashfreeSdk, setShowCashfreeSdk] = useState(false);
  const [cashfreePaymentSessionId, setCashfreePaymentSessionId] = useState(null);
  const discountRef = useRef(null);

  const { searchedQuery } = useSelector((s: RootState) => s.misc);
  const orgId = searchParams.get('orgId') || searchedQuery?.orgId;
  const txId = searchParams.get('txId') || searchedQuery?.txnId;
  const region: string | null = searchParams.get('region') || previousRegion;
  const provider = searchParams.get('provider');
  const orderId = searchParams.get('order_id');
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [billingDetails, setBillingDetails] = useState({});
  const paymentPollTimeout = React.useRef(20);
  const url = new URL(document.URL);
  const txHistoryView = Boolean(url?.search?.includes('transactionHistory'));
  const CURRENCY_SYMBOL = txInfo?.currencySymbol == 'INR' ? '₹' : 'US$';

  const getTxInfoData = async () => {
    dispatch(
      updateMiscStore({
        searchedQuery: {
          ...(searchedQuery ?? {}),
          orgId: orgId?.length ? orgId : searchParams.get('orgId'),
          txnId: txId?.length ? txId : searchParams.get('txId')
        }
      })
    );

    const param1 = orgId?.length ? orgId : searchParams.get('orgId');
    const param2 = txId?.length ? txId : searchParams.get('txId');

    let response;
    if (orderId) {
      response = await getPaidTxDetails(param1, param2, orderId);
      if (response?.data?.region) {
        setPreviousRegion(response?.data?.region);
      }
    } else {
      response = await getTxInfo(param1, param2, region, orderId, express, phoneNumber);
    }

    setLoadingData(false);
    if (response) {
      if (isClientCareerMosaic()) {
        const services = await fetchServices();
        const items = response.data?.items?.map((item: any) => {
          const service = services.find((service: any) => service.value === item.subtype);
          return {
            ...item,
            subType: item?.subType,
            subtitle: service?.name
          };
        });
        response.data.items = items;
      }
      generateBillingDetails(response.data);
      setTxInfo(response.data);
      if (response?.data?.discount) {
        discountRef.current = response?.data?.discount;
      }
      mixpanel.track(trackingEvents.payment.events.step.viewed, {
        orgId: orgId,
        txId: txId,
        region,
        documents_count: response.data?.items?.length,
        base_amount_inr: response.data?.total,
        gst_amount_inr: response.data?.gst,
        total_amount_inr: response.data?.toPay,
        currency: response.data?.currencySymbol ?? 'INR',
        discount: discountRef?.current
      });
    }
  };

  const pasteToClipboard = async (text: string) => {
    navigator.clipboard.writeText(text);
    showSnackbar('Copied', 'success');
  };

  useEffect(() => {
    if (isClientCareerMosaic() && searchParams.get('order_id')) {
      window.open('', '_self'); // replace current browsing context
      window.close();
      return;
    }
  }, []);

  React.useEffect(() => {
    if (!region && !orderId && !txHistoryView) {
      showSnackbar('Please choose a payment region before proceeding to pay', 'error');
      navigate('/choose-payment-region');
      return;
    }

    if (orgId && txId && !txHistoryView) {
      getTxInfoData();
    } else if (txHistoryView) {
      const data = state?.order;
      if (data) {
        setTxInfo({
          ...data,
          items: data?.price?.items,
          total: data?.price?.toPay,
          toPay: data?.amount,
          gst: data?.price?.gst,
          orderId: data?._id,
          transactionId: data?.transactionId,
          org: data?.org,
          updatedAt: data?.updatedAt,
          currentStatus: data?.currentStatus,
          paymentId: data?.paymentId,
          currencySymbol: data?.currencySymbol ?? data?.price?.currencySymbol,
          discount: data?.discount,
          isRefundTx: data?.refundDetails?.length > 0,
          totalAmountPaid: data?.totalAmountPaid
        });
      } else {
        navigate('/transaction-history');
      }
    }
  }, []);

  const pollStatus = (paymentId: string | null) => {
    let pId = orderId;
    if (paymentId) {
      pId = paymentId;
    }
    const id = setInterval(async () => {
      paymentPollTimeout.current = paymentPollTimeout.current - 1;
      if (paymentPollTimeout.current <= 0) {
        clearInterval(id);
        showSnackbar('Payment Failed. Please try again', 'error');
        setLoading(false);
        setPaymentStatus('');
        mixpanel.track(trackingEvents.payment.events.transaction.pending, {
          orgId: orgId,
          txId: txId,
          orderId,
          region,
          provider,
          discount: discountRef?.current,
          expressVerificationOpted: express
        });
      }
      const response = await getPaymentStatus({ orgId, paymentId: pId });
      if (!response.error) {
        setPaymentStatus(response.data.data.currentStatus);
        if (response.data.data.currentStatus == 'Success') {
          clearInterval(id);
          setLoading(false);
          setPaymentStatus('Success');
          mixpanel.track(trackingEvents.payment.events.transaction.completed, {
            orgId: orgId,
            txId: txId,
            transaction_id: pId,
            orderId,
            region,
            gateway: provider,
            currency: txInfo?.currencySymbol ?? 'INR',
            total_amount: txInfo?.toPay,
            gst_amount: txInfo?.gst,
            discount: discountRef?.current,
            expressVerificationOpted: express
          });
        }
        if (response.data.data.currentStatus == 'Failed') {
          clearInterval(id);
          showSnackbar('Payment Failed. Please try again', 'error');
          setLoading(false);
          setPaymentStatus('Failed');
          mixpanel.track(trackingEvents.payment.events.transaction.failed, {
            orgId: orgId,
            txId: txId,
            orderId,
            region,
            gateway: provider,
            error_code: response.data?.data?.currentStatus,
            currency: txInfo?.currencySymbol ?? 'INR',
            total_amount: txInfo?.toPay,
            discount: discountRef?.current,
            expressVerificationOpted: express
          });
        }
      } else {
        clearInterval(id);
        setLoading(false);
        mixpanel.track(trackingEvents.payment.events.transaction.statusAPINotResponded, {
          orgId: orgId,
          txId: txId,
          orderId,
          errorMessage: response?.message,
          region,
          provider,
          discount: discountRef?.current,
          expressVerificationOpted: express
        });
      }
    }, 6000);
  };
  React.useEffect(() => {
    const trigger = async () => {
      const paymentQuery = 'order_id=';
      const url = new URL(document.URL);
      if (url?.search?.includes(paymentQuery)) {
        setLoading(true);
        pollStatus(null);
        mixpanel.track(trackingEvents.payment.events.transaction.redirectionComplete, {
          orgId: orgId,
          txId: txId,
          orderId,
          region,
          discount: discountRef?.current,
          expressVerificationOpted: express
        });
      }
      if (state?.order?.refundDetails?.length > 0) {
        new Promise((resolve, reject) => {
          if (state?.isARefundTxn) {
            setTimeout(() => {
              shakeRef?.current?.scrollIntoView({ behavior: 'smooth' });
              resolve(0);
            }, 800);
          } else {
            resolve(0);
          }
        }).then(() => {
          setTimeout(() => {
            startShake();
          }, 400);
        });
      }
    };
    // in case of paypal, when payment is cancelled and payment region redirects the user back to wallet
    if (searchParams?.get('cancelled')) {
      mixpanel.track(trackingEvents.payment.events.transaction.cancelled, {
        orgId: orgId,
        txId: txId,
        region,
        provider
      });
      showSnackbar('Payment Cancelled', 'error');
    } else {
      trigger();
    }
  }, []);

  const generateRedirectionLink = (environment: string, sdkName: string, sessionId: string) => {
    return `${import.meta.env.VITE_PAYMENT_REDIRECTION_ORIGIN}?sdkProvider=${sdkName}&paymentSessionId=${sessionId}&environment=${environment}`;
  };

  const initiatePayment = async () => {
    if (!region) {
      showSnackbar('Please select the payment option first', 'error');

      return <Navigate to="choose-payment-region" />;
    }
    if (paymentStatus === 'Failed') {
      mixpanel.track(trackingEvents.payment.events.transaction.retried, {
        orgId: orgId,
        txId: txId,
        region,
        expressVerificationOpted: express
      });
    }
    mixpanel.track(trackingEvents.payment.events.transaction.initiationStarted, {
      orgId: orgId,
      txId: txId,
      region,
      discount: discountRef?.current,
      expressVerificationOpted: express
    });
    mixpanel.track(trackingEvents.payment.events.transaction.initiated, {
      orgId: orgId,
      txId: txId,
      region,
      discount: discountRef?.current,
      expressVerificationOpted: express
    });
    setLoading(true);
    const response = await initPayment(orgId, txId, region, express, phoneNumber);
    if (response.data) {
      mixpanel.track(trackingEvents.payment.events.transaction.started, {
        orgId: orgId,
        txId: txId,
        region,
        redirectInfo: response?.data?.data?.redirectInfo,
        discount: discountRef?.current,
        provider: response?.data?.data?.provider,
        expressVerificationOpted: express
      });

      let link = response?.data?.data?.redirectInfo?.web;

      if (
        response?.data?.data?.provider == SDK_LIST.CASHFREE &&
        response?.data?.data?.paymentSessionId
      ) {
        setShowCashfreeSdk(true);
        setCashfreePaymentSessionId(response?.data?.data?.paymentSessionId);
        link = generateRedirectionLink(
          import.meta.env.VITE_CASHFREE_PAYMENT_MODE,
          SDK_LIST.CASHFREE,
          response?.data?.data?.paymentSessionId
        );
      }
      if (isClientCareerMosaic()) {
        pollStatus(response?.data?.data?.paymentId);
        return window.open(link, '_blank');
      }
      mixpanel.track(trackingEvents.payment.events.transaction.gatewayRedirected, {
        orgId: orgId,
        txId: txId,
        region,
        gateway: response?.data?.data?.provider,
        expressVerificationOpted: express
      });
      window.location.href = link;
    } else {
      setLoading(false);
      mixpanel.track(trackingEvents.payment.events.transaction.initiationFailed, {
        orgId: orgId,
        txId: txId,
        region,
        discount: discountRef?.current,
        expressVerificationOpted: express
      });
    }
  };

  const generateBillingDetails = (data: { verificationList: any }) => {
    let total = 0;
    data?.verificationList?.map((i: any) => {
      total += i.credits;
    });
    const gst = 0.18 * total;
    const toPay = total + gst;
    setBillingDetails({
      total,
      gst,
      toPay
    });
  };

  const getGstPercentage = () => {
    if (!txInfo?.gst || !txInfo?.total) return null;
    const total: any = (txInfo?.total - (txInfo?.discount?.amount ?? 0)).toFixed(2);
    const percentage = (txInfo?.gst / total) * 100;
    return `${Math.round(percentage)}%`;
  };

  if (paymentStatus == 'Success') return <Navigate to="/submitted" />;
  const gstPercentage = getGstPercentage();

  return (
    <HeadingArrowWrapper
      sx={{
        // maxWidth: '400px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
        height: '100%',
        // alignItems: 'center',
        padding: '0',
        margin: 'auto'
      }}
      title={'Payment Details'}>
      <Grid
        item
        sx={{
          width: '100%',
          height: '100%',
          overflowY: 'auto'
        }}>
        {!txHistoryView && (<Alert
          severity="warning"
          sx={{ width: '100%', justifyContent: 'center', alignItems: 'center', mt: 1 }}>
          <Typography>
            Please note that you need to enable International Usage on your card before making the
            payment.
          </Typography>
        </Alert>)}
        {txHistoryView ? (
          <Grid
            sx={{
              mt: 1,
              background: 'url(' + paymentBlueBackground + ')',
              padding: '10px',
              borderRadius: 2,
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover'
            }}
            container
            direction="row"
            justifyContent="space-between"
            alignItems="flex-start">
            <Box>
              <Grid container direction="row" alignItems="center">
                <Avatar sx={{ width: 40, height: 40 }} src={txInfo?.org?.imageUrl} />
                <Box sx={{ ml: '20px' }}>
                  <Typography sx={{ overflowWrap: 'break-word' }}>
                    {txInfo?.org?.displayName}
                  </Typography>
                  <Typography sx={{ color: '#404052', mt: '4px', fontWeight: 600 }}>
                    {displayTime(txInfo?.createdAt, 'DD-MMM-YYYY | hh:mm:A')}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      color: '#000000',
                      display: 'flex',
                      alignItems: 'center',
                      fontWeight: 600
                    }}>
                    Paid via {paymentProvider[txInfo?.provider as paymentProvidersTypes]?.name}
                    <div style={{ marginLeft: '4px', display: 'flex', alignItems: 'center' }}>
                      <img
                        src={paymentProvider[txInfo?.provider as paymentProvidersTypes]?.src}
                        height={12}
                        alt={`${paymentProvider[txInfo?.provider as paymentProvidersTypes]?.name} logo`}
                      />
                    </div>
                  </Typography>
                </Box>
              </Grid>
            </Box>
            {txInfo?.currentStatus && (
              <Chip
                color={getTagStructuredData(txInfo?.currentStatus?.toUpperCase())?.theme as themes}
                variant="outlined"
                sx={{
                  ...styles.chip,
                  border: 'none',
                  color: getTagStructuredData(txInfo?.currentStatus?.toUpperCase())?.color,
                  bgcolor: '#ffffff',
                  borderColor: '#000000',
                  borderRadius: 1,
                  padding: '0px 8px',
                  fontWeight: 600
                }}
                size="small"
                icon={<>{getTagStructuredData(txInfo?.currentStatus?.toUpperCase())?.icon}</>}
                label={getTagStructuredData(txInfo?.currentStatus?.toUpperCase())?.text}
              />
            )}
          </Grid>
        ) : null}
        <Grid container justifyContent="space-between" sx={{ mt: 2, mb: 0 }}>
          <List sx={{ ...style, pb: 0 }}>
            {txInfo?.items?.map((item: any, key: number) => {
              return (
                <>
                  <ListItem
                    key={key}
                    secondaryAction={
                      <Stack direction={'row'}>
                        {item?.mrp && parseFloat(item?.mrp) > parseFloat(item?.price) ? (
                          <Typography
                            sx={{
                              fontWeight: '500',
                              textDecoration: 'line-through',
                              fontSize: 12
                            }}>
                            {CURRENCY_SYMBOL}
                            {item?.mrp}
                          </Typography>
                        ) : null}
                        <Typography sx={{ fontWeight: '700', marginLeft: 0.5, fontSize: 15 }}>
                          {CURRENCY_SYMBOL}
                          {item?.price}
                        </Typography>
                      </Stack>
                    }>
                    <ListItemAvatar
                      sx={{
                        padding: '0em',
                        display: 'flex',
                        justifyContent: { xs: 'center', sm: 'flex-start' }
                      }}>
                      {item?.iconUrl || item?.icon ? (
                        <Avatar src={item?.iconUrl ?? item?.icon ?? ''} />
                      ) : (
                        <BackgroundLetterAvatars
                          name={
                            item?.label == 'Degree'
                              ? `${item?.description} ${item?.label}`
                              : item?.label
                          }
                          sx={{ width: '35px', height: '35px' }}
                        />
                      )}
                    </ListItemAvatar>
                    <ListItemText
                      sx={{ marginLeft: 1, fontWeight: '400' }}
                      primary={
                        item?.label == 'Degree'
                          ? `${item?.description} ${item?.label}`
                          : item?.label
                      }
                      secondary={item?.subtitle || convertToTitleCase(item?.item)}
                    />
                  </ListItem>
                  <Divider component="li" />
                </>
              );
            })}
          </List>
        </Grid>

        <Grid container justifyContent="space-between" sx={{ mt: 2, mb: 0 }}>
          <Typography
            sx={{ textAlign: 'left', display: 'flex', alignItems: 'center' }}
            variant="body1M"
            component="h2">
            <img src={billingSummaryIcon} alt="Billing Summary Icon" />
            &nbsp; Billing Summary
          </Typography>
        </Grid>
        {txInfo?.availableDiscount && (
          <Alert
            severity="info"
            sx={{ width: '100%', alignItems: 'center', backgroundColor: '#E4F1FF' }}>
            <Typography sx={{ color: '#073B72' }}>
              To get a {txInfo?.availableDiscount?.percentage}% discount, your cart value must be at
              least {txInfo?.availableDiscount?.minAmount[region ?? '']?.currency}{' '}
              {txInfo?.availableDiscount?.minAmount[region ?? '']?.amount}
            </Typography>
          </Alert>
        )}
        <List sx={{ ...style, pb: 0 }}>
          {!txHistoryView && (
            <span>
              <ListItem
                secondaryAction={
                  <Typography
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'center',
                      alignItems: 'center',
                      fontWeight: '700'
                    }}>
                    {import.meta.env.VITE_DISCOUNT_VALUE ? (
                      <>
                        <Tooltip title="Limited time offer" sx={{ fontSize: '2.6rem' }}>
                          <InfoOutlined sx={{ fontSize: '1.6rem', marginRight: '0.2em' }} />
                        </Tooltip>
                        <span
                          style={{
                            textDecoration: 'line-through',
                            marginRight: '0.5em'
                          }}
                          data-test-id={DATA_TEST_IDS.DISCOUNT_VALUE}>
                          {CURRENCY_SYMBOL}
                          {import.meta.env.VITE_DISCOUNT_VALUE}
                        </span>
                      </>
                    ) : null}
                    {txInfo?.totalAmountPaid
                      ? `${CURRENCY_SYMBOL}${txInfo?.totalAmountPaid}`
                      : txInfo?.total
                        ? `${CURRENCY_SYMBOL}${parseFloat(txInfo?.total) + parseFloat(txInfo?.discount?.mrpDiscount ?? 0)}`
                        : '-'}
                  </Typography>
                }>
                <ListItemText
                  sx={{ fontWeight: '400' }}
                  primary={
                    <Stack direction={'row'} spacing={1}>
                      <img
                        src={ItemTotalIcon}
                        style={{ height: 15, width: 15 }}
                        alt="Item Total Icon"
                      />
                      <Typography>Item Total</Typography>
                    </Stack>
                  }
                />
              </ListItem>
              <Divider component="li" />
            </span>
          )}
          {!txHistoryView &&
            txInfo?.discount &&
            txInfo?.discount?.mrpDiscount > 0 && (
              <span>
                <ListItem
                  secondaryAction={
                    <Typography sx={{ fontWeight: '500', color: '#239D56' }}>
                      {txInfo?.discount?.mrpDiscount
                        ? `- ${CURRENCY_SYMBOL} ${txInfo.discount?.mrpDiscount}`
                        : '-'}
                    </Typography>
                  }>
                  <ListItemText
                    sx={{ fontWeight: '400' }}
                    primary={
                      <Stack direction={'row'} spacing={1}>
                        <img
                          src={OfferDiscountIcon}
                          style={{ height: 15, width: 15 }}
                          alt="Offer Discount Icon"
                        />
                        <Typography>Offer Discount</Typography>
                      </Stack>
                    }
                  />
                </ListItem>
                <Divider component="li" />
              </span>
            )}
          {!txHistoryView &&
            txInfo?.discount &&
            txInfo?.discount?.amount && (
              <span>
                <ListItem
                  secondaryAction={
                    <Typography sx={{ fontWeight: '500', color: '#239D56' }}>
                      {txInfo?.discount?.amount
                        ? `- ${CURRENCY_SYMBOL} ${txInfo.discount?.amount}`
                        : '-'}
                    </Typography>
                  }>
                  <ListItemText
                    sx={{ fontWeight: '400' }}
                    primary={
                      <Stack direction={'row'} spacing={1}>
                        <img
                          src={AdditionalDiscountIcon}
                          style={{ height: 15, width: 15 }}
                          alt="Additional Discount Icon"
                        />
                        <Typography>
                          Additional Discount{' '}
                          <span style={{ color: '#CCA107', fontWeight: '700' }}>
                            {`(${txInfo?.discount?.percentage}% Discount)`}
                          </span>
                        </Typography>
                      </Stack>
                    }
                  />
                </ListItem>
                <Divider component="li" />
              </span>
            )}
          {!txHistoryView && txInfo?.toPayBeforeGst ? (
            <span>
              <ListItem
                secondaryAction={
                  <Stack direction="row" spacing={1}>
                    <Typography sx={{ fontWeight: 'bold' }}>
                      {CURRENCY_SYMBOL}
                      {txInfo?.toPayBeforeGst}
                    </Typography>
                  </Stack>
                }>
                <ListItemText
                  sx={{ fontWeight: '600' }}
                  primary={
                    <Stack direction={'row'} spacing={1}>
                      <img
                        src={GrandTotalIcon}
                        style={{ height: 15, width: 15 }}
                        alt="Grand Total Icon"
                      />
                      <Typography>Grand Total </Typography>
                    </Stack>
                  }
                />
              </ListItem>
              <Divider component="li" />
            </span>
          ) : null}
          {!txHistoryView &&
          txInfo?.gst > 0 &&
          gstPercentage !== null ? (
            <span>
              <ListItem
                secondaryAction={
                  <Typography sx={{ fontWeight: '500' }}>
                    {txInfo.gst ? `${CURRENCY_SYMBOL}${txInfo.gst}` : '-'}
                  </Typography>
                }>
                <ListItemText
                  sx={{ fontWeight: '400' }}
                  primary={
                    <Stack direction={'row'} spacing={1}>
                      <img src={TaxesIcon} style={{ height: 15, width: 15 }} alt="Taxes Icon" />
                      <span>Taxes ({gstPercentage})</span>
                    </Stack>
                  }
                />
              </ListItem>
              <Divider component="li" />
            </span>
          ) : null}
          <span>
            <ListItem
              secondaryAction={
                <Stack direction="row" spacing={1}>
                  <Typography sx={{ fontWeight: 'bold' }}>
                    {txInfo.toPay ? `${CURRENCY_SYMBOL}${txInfo.toPay}` : '-'}
                  </Typography>
                </Stack>
              }>
              <ListItemText
                sx={{ fontWeight: '600' }}
                secondaryTypographyProps={{ fontWeight: 'bold', color: '#8F8F92' }}
                primary={
                  <Stack direction={'row'} spacing={1}>
                    <img src={ToPayIcon} style={{ height: 15, width: 15 }} alt="To Pay Icon" />
                    <Stack direction={'column'}>
                      <Typography>{txHistoryView ? 'Amount Paid' : 'To Pay'}</Typography>
                      <Typography sx={{ paddingTop: 0.5, fontSize: 10 }} variant="body2">
                        {txHistoryView ? '' : 'Incl. all taxes and charges'}
                      </Typography>
                    </Stack>
                  </Stack>
                }
                secondary={!txHistoryView ? '' : 'Incl. all taxes and charges'}
              />
            </ListItem>
            <Divider component="li" />
          </span>
          {txInfo?.discount &&
            (txInfo?.discount?.amount > 0 || txInfo?.discount?.mrpDiscount > 0) &&
            ([WES_ORG, CES_ORG]?.includes(import.meta.env.VITE_ORG) ||
            import.meta.env.VITE_NSDC_PARTNER ? (
              <Box
                sx={{
                  width: '100%', // Set width as needed
                  // height: '200px', // Set height as needed
                  background: 'linear-gradient(45deg, #155E34, #2CC46C)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'white',
                  fontWeight: 'bold',
                  p: 1.2,
                  borderBottomLeftRadius: 5,
                  borderBottomRightRadius: 5
                }}>
                <Typography sx={{ color: '#fff' }}>
                  {`🥳 You saved ${CURRENCY_SYMBOL}${parseFloat(txInfo?.discount?.amount ?? 0) + parseFloat(txInfo?.discount?.mrpDiscount ?? 0)} with NSDC Trust`}
                </Typography>
              </Box>
            ) : (
              <span>
                <ListItem
                  sx={{
                    backgroundColor: '#F4FFEE',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}>
                  <Typography sx={{ fontWeight: 'bold', color: '#239D56' }}>
                    {`You are saving ${CURRENCY_SYMBOL} ${parseFloat(txInfo?.discount?.amount ?? 0) + parseFloat(txInfo?.discount?.mrpDiscount ?? 0)}`}
                  </Typography>
                </ListItem>
              </span>
            ))}
        </List>
        {txHistoryView && (
          <>
            <Grid container justifyContent="space-between" sx={{ mt: 1, mb: 0 }}>
              <Typography
                sx={{ textAlign: 'left', display: 'flex', alignItems: 'center' }}
                variant="body1M"
                component="h2">
                <ReceiptLongOutlined sx={{ fontSize: '1.4em' }} /> &nbsp; Transaction Details
              </Typography>
            </Grid>
            <Grid container direction="column" sx={style}>
              <Grid
                item
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  padding: '1em'
                }}>
                <Typography sx={{ fontWeight: 400 }}>Payment ID</Typography>
                <Typography
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    fontWeight: '500',
                    cursor: 'pointer'
                  }}
                  onClick={() => pasteToClipboard(txInfo?.paymentId)}>
                  {txInfo?.paymentId} &nbsp;
                  <ContentCopy sx={{ fontSize: '1.6rem' }} />
                </Typography>
              </Grid>

              <Divider sx={dividerStyle} />

              <Grid
                item
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  padding: '1em'
                }}>
                <Typography sx={{ fontWeight: 400 }}>Transaction ID</Typography>
                <Typography
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    fontWeight: '500',
                    cursor: 'pointer'
                  }}
                  onClick={() => pasteToClipboard(txInfo?.transactionId)}>
                  {txInfo?.transactionId} &nbsp;
                  <ContentCopy sx={{ fontSize: '1.6rem' }} />
                </Typography>
              </Grid>
            </Grid>
          </>
        )}

        {txInfo?.refundDetails?.length > 0 ? (
          <>
            <Grid container justifyContent="space-between" sx={{ mt: 2, mb: 0 }}>
              <Typography
                sx={{ textAlign: 'left', display: 'flex', alignItems: 'center' }}
                variant="h1"
                component="h2">
                <img src={refundIcon} alt="Refund Icon" />
                &nbsp; Refunds
              </Typography>
            </Grid>
            <List dense sx={{ ...style, background: '#F5F9FC' }}>
              {txInfo?.refundDetails
                ?.sort((a: any, b: any) => b.createdAt - a.createdAt)
                ?.map((refund: any, i: number) => (
                  <Box
                    ref={refund?._id === state?.txnSelected ? shakeRef : null}
                    sx={{
                      marginTop: i > 0 ? '1em' : 0,
                      bgcolor: '#ffffff',
                      padding: '1em 0',
                      borderRadius: 2
                      // ...(refund?._id === state?.txnSelected
                      //   ? { animation: `${blink} 0.2s 1 forwards` }
                      //   : {})
                    }}>
                    <Grid
                      container
                      direction="row"
                      justifyContent="space-between"
                      sx={{ margin: '0' }}>
                      <Grid item xs={8} sm={8} md={10} sx={{ padding: '1em' }}>
                        <ListItemText
                          primary={refund?.reason}
                          primaryTypographyProps={{ sx: { fontWeight: 'bold' } }}
                          secondary={displayTime(refund?.createdAt, 'DD-MMM-YYYY,  hh:mm:ss:A')}
                        />{' '}
                      </Grid>
                      <Grid
                        item
                        xs={4}
                        sm={4}
                        md={2}
                        sx={{
                          padding: '1em',
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'flex-end'
                        }}>
                        <Typography
                          sx={{
                            fontWeight: 'bold',
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'flex-end'
                          }}>
                          {CURRENCY_SYMBOL}
                          {refund?.amount}
                        </Typography>
                        <Chip
                          color={
                            getTagStructuredData(refund?.status?.toUpperCase())?.theme as themes
                          }
                          variant="outlined"
                          sx={{
                            ...styles.chip,
                            color: getTagStructuredData(refund?.status?.toUpperCase())?.color,
                            bgcolor: getTagStructuredData(refund?.status?.toUpperCase())?.bgColor
                          }}
                          size="small"
                          icon={<>{getTagStructuredData(refund?.status?.toUpperCase())?.icon}</>}
                          label={getTagStructuredData(refund?.status?.toUpperCase())?.text}
                        />
                      </Grid>
                    </Grid>
                    <List sx={{ ...style, margin: '1em auto', p: 0 }}>
                      <span>
                        <ListItem
                          sx={{ cursor: 'pointer', m: '1rem' }}
                          onClick={() => pasteToClipboard(refund?.refundId)}
                          secondaryAction={
                            <Typography
                              sx={{ fontWeight: '500', display: 'flex', alignItems: 'center' }}>
                              {refund?.refundId}
                              &nbsp;
                              <ContentCopy sx={{ fontSize: '1.6rem' }} />
                            </Typography>
                          }>
                          <ListItemText sx={{ fontWeight: '400', m: 0 }} primary={'Refund ID'} />
                        </ListItem>
                        <Divider component="li" sx={dividerStyle} />
                      </span>
                      <span>
                        <ListItem
                          sx={{ cursor: 'pointer', m: '1rem' }}
                          onClick={() => pasteToClipboard(refund?._id)}
                          secondaryAction={
                            <Typography
                              sx={{ fontWeight: '500', display: 'flex', alignItems: 'center' }}>
                              {refund?._id}
                              &nbsp;
                              <ContentCopy sx={{ fontSize: '1.6rem' }} />
                            </Typography>
                          }>
                          <ListItemText
                            sx={{ fontWeight: '400', m: 0 }}
                            primary={'Transaction ID'}
                          />
                        </ListItem>
                        {/* <Divider component="li" /> */}
                      </span>
                    </List>
                  </Box>
                ))}
            </List>
          </>
        ) : null}
      </Grid>

      <Box sx={styles.bottomStickyWrapper}>
        {!txHistoryView && txInfo?.disclaimer?.length > 0 && (
          <Alert
            severity="info"
            sx={{ width: '100%', justifyContent: 'center', alignItems: 'center' }}>
            <Typography>{txInfo?.disclaimer}</Typography>
          </Alert>
        )}
        {txHistoryView ? null : (
          <LoadingButton
            loading={loading}
            onClick={async () => initiatePayment()}
            variant="contained"
            sx={{ fontWeight: 600, margin: '0em 0' }}
            id="pay">
            Continue to Pay {CURRENCY_SYMBOL}
            {txInfo?.toPay}
          </LoadingButton>
        )}
        {paymentStatus == 'Pending' && paymentPollTimeout.current > 0 && (
          <Typography sx={{ textAlign: 'center' }}>
            Please wait while we fetch the payment status
          </Typography>
        )}
      </Box>
    </HeadingArrowWrapper>
  );
};

export default Payment;
